import { render, staticRenderFns } from "./fail.vue?vue&type=template&id=5cf8bb3d"
import script from "./fail.vue?vue&type=script&lang=js"
export * from "./fail.vue?vue&type=script&lang=js"
import style0 from "./fail.vue?vue&type=style&index=0&id=5cf8bb3d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports